<template>
  <section class="section featured-resource" v-if="results">

    <div class="container mx-auto px-4">

      <h3 class="featured-resource__title">Featured Resource</h3>

      <div class="featured-resource__card">

        <div class="featured-resource__image" :style="`background-image: url(${$filters.analyseImage(featured['cover-image'],'herosearchxs','herosearchsm')});`">
          <button :class="`pill ${pillColor}`" v-if="featured['resource-type']">{{ featured['resource-type'] }}</button>
        </div>

        <div class="featured-resource__body">
          <h4 class="featured-resource__body-title">{{ featured['title'] }}</h4>
          <p>{{ featured['summary'] }}</p>
          <a class="btn btn-blue-light btn-medium btn-rounded" :href="`/${$filters.convertResourceType(featured['resource-type'])}/${featured['slug']}`">View</a>
        </div>

      </div>

    </div>

  </section>
</template>

<script>
import algoliasearch from 'algoliasearch';

	export default {
		components: {

		},
		data() {
			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'resources-dev' : 'resources-live',
				searchObject: {
					hitsPerPage: 1,
					facets: ["featured"],
					facetFilters: [["featured:true"]]
				},
				results: false
			}
		},
		methods: {

		},
		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);


			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("featured resource search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		},
		computed: {
			featured() {
				return this.results[0];
			},
			pill_classes() {
				return {
					'pill':true,
					'bg-blue-light': true // bg-green, bg-purple
				}
			},
      pillColor() {
        let result = this.featured['resource-type'] ? this.featured['resource-type'].replace(/\s+/g, '-').toLowerCase() : 'default';
        return result;
      },
		}
	}
</script>

<style>

</style>
